import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { JeanologiaSsoAuthGuard } from "@jeanologia/ng-ssoauth";

import { Constants } from "./features/models/constants/_constants";
import { DefaultLayoutComponent } from "./features/containers/default-layout/default-layout.component";
import { PrivatePolicyViewComponent } from "./shared/components/views/private-policy-view/private-policy-view.component";
import { CookiesPolicyViewComponent } from "./shared/components/views/cookies-policy-view/cookies-policy-view.component";

const routes: Routes = [
	{
		path: "",
		redirectTo: "private",
		pathMatch: "full",
	},
	{
		path: Constants.rPreRegistration,
		loadChildren: () => import("./features/pre-registration-view/pre-registration-view.module").then((m) => m.PreRegistrationViewModule),
	},
	{
		path: Constants.rRegistration,
		loadChildren: () => import("./features/registration-view/registration-view.module").then((m) => m.RegistrationViewModule),
	},
	{
		path: Constants.rPreRegistration + "/" + Constants.rPrivatePolicy,
		component: PrivatePolicyViewComponent,
		data: {
			title: "private-policy",
		},
	},
	{
		path: Constants.rRegistration + "/" + Constants.rPrivatePolicy,
		component: PrivatePolicyViewComponent,
		data: {
			title: "private-policy",
		},
	},
	{
		path: Constants.rPreRegistration + "/" + Constants.rCookiePolicy,
		component: CookiesPolicyViewComponent,
		data: {
			title: "cookie-policy",
		},
	},
	{
		path: Constants.rRegistration + "/" + Constants.rCookiePolicy,
		component: CookiesPolicyViewComponent,
		data: {
			title: "cookie-policy",
		},
	},
	{
		path: "private",
		component: DefaultLayoutComponent,
		canActivate: [JeanologiaSsoAuthGuard],
		loadChildren: () => import("./features/private/private.module").then((m) => m.PrivateModule),
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { enableTracing: false })],
	exports: [RouterModule],
})
export class AppRoutingModule {
	constructor() {}
}
